import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FoundationLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseFoundationLevelIds,
]);

export const FoundationBasementLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseFoundationLevelIds,
]);

export const FramingLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseFramingLevelIds,
]);

export const InternalFramingLevelIds = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseIntFramingLevelIds,
]);

export const ExternalFramingLevelIds = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseExtFramingLevelIds,
]);

export const FlooringLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseFlooringLevelIds,
]);

export const DecksAndPorchesLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseDecksAndPorchesLevelIds,
]);

export const WindowsLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseWindowsLevelIds,
]);

export const DoorsLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseDoorsLevelIds,
]);

export const CeilingsLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseCeilingsLevelIds,
]);

export const InsulationLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseInsulationLevelIds,
]);

export const DrywallLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseDrywallLevelIds,
]);

export const MillworkLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseMillworkLevelIds,
]);

export const InteriorFinishesLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseInteriorFinishesLevelIds,
]);

export const ExteriorFinishesLevelId = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseExteriorFinishesLevelIds,
]);

export const IntWallCladdingLevelIds = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseIntWallCladdingLevelIds,
]);

export const ExtWallCladdingLevelIds = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseExtWallCladdingLevelIds,
]);

export const IntFixturesLevelIds = iotsUtils.fromList([
	...constants.wholeHouse.takeOff.wholeHouseIntFixturesLevelIds,
]);

export const Id = iotsUtils.fromList(constants.wholeHouse.takeOff.ids);
